import { baseURL } from "./config";
import { defaultLanguageJSON } from "./constant";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const toastList = new Set();
const MAX_TOAST = 1;

export const getJSON = (url, callback) => {
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  xhr.open('GET', url, true);
  xhr.onreadystatechange = function () {
    if (xhr.readyState == 4 && xhr.status == "200") {
      callback(xhr.responseText);
    }
  };
  xhr.send();
};

export const getContent = (languageJSON, key, requestParams) => {
  let staticContent = languageJSON[key] || defaultLanguageJSON[key];
  if (requestParams) {
    staticContent = staticContent.replace('<%<providerOrg>%>', 'OnGrid')
    staticContent = staticContent.replace('<%<requestingOrg>%>', requestParams.additionalParams ? requestParams.additionalParams.clientName : '')
  }
  return staticContent;
}

export const getURLByKey = (key, token, callback) => {
  let url = baseURL + 'client/url/' + key
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'X-Request-Token': token,
    }
  })
    .then(response => response.json())
    .then(data => {
      callback(data)
    });
}

export const isMobileDevice = {
  Android: function () {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },
  any: function () {
    return (isMobileDevice.Android() || isMobileDevice.BlackBerry() || isMobileDevice.iOS() || isMobileDevice.Opera() || isMobileDevice.Windows());
  }
};

export const getBrowser = () => {
  if (navigator.userAgent.indexOf("Edge") > -1 && navigator.appVersion.indexOf('Edge') > -1) {
    return 'Edge';
  }
  else if (navigator.userAgent.indexOf("Opera") != -1 || navigator.userAgent.indexOf('OPR') != -1) {
    return 'Opera';
  }
  else if (navigator.userAgent.indexOf("Chrome") != -1) {
    return 'Chrome';
  }
  else if (navigator.userAgent.indexOf("CriOS") != -1) {
    return 'CriOS';
  }
  else if (navigator.userAgent.indexOf("Safari") != -1) {
    return 'Safari';
  }
  else if (navigator.userAgent.indexOf("Firefox") != -1) {
    return 'Firefox';
  }
  else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
  {
    return 'IE';
  }
  else {
    return 'unknown';
  }
}

export const convertToBinary = (url) => {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(res => res.blob())
      .then(blob => {
        let file = {
          fileName: 'a',
          fileExt: blob.type.split('/').pop(),
          type: blob.type
        }
        let binaryFile = new File([blob], `${file.fileName}.${file.fileExt}`, { type: file.type });
        resolve(binaryFile);
      }).catch((error) => {

      })
  }).catch((error) => {

  })
}

export const uploadFileToSignedURL = (url, file) => {
  return new Promise((resolve, reject) => {
    // const formData = new FormData();
    // formData.append("file", file);
    let options = {
      method: 'PUT',
      body: file,
    }
    fetch(url, options)
      .then(res => {
        if (res.status == 200)
          resolve(true)
      }).catch((error) => {
        reject(false)
      })
  })
}

export const customAlert = (
  message,
  type
) => {
  if (toastList.size < MAX_TOAST) {
    let toastDefaultOptions = {
      position: "top",
      autoClose: false,
      closeOnClick: true,
      onClose: () => toastList.delete(id),
      hideProgressBar: true,
      className: type === 'info' ? 'primary-background' : ''
    }
    const id = toast[type](message, {
      ...toastDefaultOptions
    });
    toastList.add(id);
  }
}

export const handleError = (error) => {
  customAlert(error.message, 'error')
}

export const handleSuccess = (message) => {
  customAlert(message, 'success')
}